import React from "react";
import { Link } from "react-router-dom";
import Icon1 from "../Assets/img/explore-topic/topic-1.svg";
import Icon2 from "../Assets/img/explore-topic/topic-2.svg";
import Icon3 from "../Assets/img/explore-topic/topic-3.svg";
import Icon4 from "../Assets/img/explore-topic/topic-4.svg";
import Icon5 from "../Assets/img/explore-topic/topic-5.svg";
import Icon6 from "../Assets/img/explore-topic/topic-6.svg";

const ExploreTopic = () => {
  const ExploreTopicMain = [
    {
      id: "item1",
      icon: Icon1,
      title: "Introduction",
      text: "Getting Started to The Application",
      explorenumber: "10",
    },
    {
      id: "item2",
      icon: Icon2,
      title: "Installation",
      text: "Authentication and Account Settings Guide",
      explorenumber: "08",
    },
    {
      id: "item3",
      icon: Icon3,
      title: "Authentication",
      text: "Getting Started to The Application",
      explorenumber: "05",
    },
    {
      id: "item4",
      icon: Icon4,
      title: "Application Workflow",
      text: "Getting Started to The Application",
      explorenumber: "10",
    },
    {
      id: "item5",
      icon: Icon5,
      title: "User Settings",
      text: "Getting Started to The Application",
      explorenumber: "08",
    },
    {
      id: "item6",
      icon: Icon6,
      title: "System Settings",
      text: "Getting Started to The Application",
      explorenumber: "05",
    },
  ];

  return (
    <>
      <section className="explore-topic-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 col-12">
              <div className="section-title">
                <h3>Explore Topics</h3>
                <p>
                  Volutpat euismod mauris, ut sed quis interdum facilisis. Ut
                  condimentum imperdiet luctus lorem eget vitae sit commodo
                  lectus. Metus mauris.
                </p>
              </div>
            </div>
          </div>
          <div className="row g-0">
            {ExploreTopicMain.map((SingleCard) => (
              <div className="col-lg-4 col-md-4 col-12" key={SingleCard.id}>
                <div className="single-topic">
                  <img src={SingleCard.icon} alt="#" />
                  <div className="single-topic-content">
                    <h4 className="t-title">{SingleCard.title}</h4>
                    <p>{SingleCard.text}</p>
                    <div className="single-topic-btn">
                      <Link href="#" className="topic-btn">
                        <span>{SingleCard.explorenumber}</span>View all
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ExploreTopic;
